import { axios } from '@/axios-client'
import { formatDate } from '@/utilities/date'

const FOR_SALE_STATUSES = ['applied', 'open']

function getPropertyId() {
  return location.pathname.match(/^\/seller\/properties\/(\d+)\/edit/)[1]
}

function fetchProperty() {
  const url = `/seller/properties/${getPropertyId()}.json`
  return axios.get(url).then(({ property }) => property)
}

function fetchViewings(search) {
  search = search || {}
  const url = `/seller/properties/${getPropertyId()}/viewings.json`
  const params = { search }
  return axios.get(url, { params }).then(({ viewings }) => viewings)
}

function setConfirmationModalText(createdViewings, approvedViewings) {
  let title = []
  let message = []

  if (createdViewings.length) {
    title.push('未対応')
    message.push(`・未対応の内見依頼${createdViewings.length}件を却下します。`)
  }
  if (approvedViewings.length) {
    title.push('許諾済み')
    message.push(`・以降に予約されている許諾済み、または手動で作成した内見依頼${approvedViewings.length}件を取下げます。`)
  }
  title = title.join('・') + 'の内見依頼があります'
  message = message.join('<br>') + '<br><br>よろしいですか？'

  const $modal = $('#planned-viewing-confirmation-modal')
  $modal.find('.confirmation-modal-title h5').html(title)
  $modal.find('.confirmation-modal-message').html(message)
}

async function checkNeedForConfirmation() {
  const status = $('input:radio[name="property[status]"]:checked').val()
  if (FOR_SALE_STATUSES.includes(status)) {
    return false
  }

  const property = await fetchProperty()
  if (!FOR_SALE_STATUSES.includes(property.status)) {
    return false
  }

  const createdViewings = await fetchViewings({
    status: ['created'],
  })
  const approvedViewings = await fetchViewings({
    status: ['approved'],
    start_at_from: formatDate(new Date(), 'datetime'),
  })
  if (createdViewings.length + approvedViewings.length === 0) {
    return false
  }
  setConfirmationModalText(createdViewings, approvedViewings)
  return true
}

$(document).ready(function() {
  $('.tooltipped').tooltip({
    enterDelay: 0,
    exitDelay: 0,
    inDuration: 0,
    outDuration: 0,
  })

  const propertyFormOnSubmit = async event => {
    event.preventDefault()

    const form = $('.property-form')[0]
    if (!form.checkValidity()) {
      return form.reportValidity()
    }

    if (await checkNeedForConfirmation()) {
      const modal = document.getElementById('planned-viewing-confirmation-modal')
      const modalInstance = M.Modal.getInstance(modal)
      modalInstance.open()
    } else {
      $('.property-form').off('submit', propertyFormOnSubmit)
      $('.property-form').trigger('submit')
    }
  }
  $('.property-form-update').on('submit', propertyFormOnSubmit)

  $('.property-form .property-form-submit-check').on('click', () => {
    $('.property-form').trigger('submit')
  })

  $('.property-form .property-form-submit').on('click', event => {
    $('.property-form').off('submit', propertyFormOnSubmit)
    $('.property-form').trigger('submit')
  })

  $(".property-document-form").each(function() {
    const form = $(this)
    form.find("input[type=file]").on("change", function() {
      form.find("input[type='submit']").click()
    })
  })
})
